import StatusBadgeModule from './status-badge.module'

export default StatusBadgeModule
